import React, {useState, useEffect, useContext} from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';
import closeButton from '../../static_files/closeButtonHover.svg';
import reserveSuccessImg from '../../static_files/reserveSuccess.svg';
import GoBackArrow from '../../static_files/goBackArrow.svg';

import {PRISMAX_BACKEND_URL} from "../../configs/config";
import {SwapMainAppContext} from "../../context/SwapMainAppContext";


function ReserveInfoModal({onClose, onGoBack, robotName = "Robot", robotImage}) {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phoneCountryCode: '+1',
        phoneNumber: '',
        email: '',
        projectCompany: '',
        location: '',
        telegram: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [hasStoredEmail, setHasStoredEmail] = useState(false);
    const {
        showNotification,
        gatewayToken
    } = useContext(SwapMainAppContext);
    useEffect(() => {
        // Check if email exists in localStorage and pre-fill it
        const storedEmail = localStorage.getItem('userEmail');
        if (storedEmail) {
            setFormData(prev => ({...prev, email: storedEmail}));
            setHasStoredEmail(true);
        }
    }, []);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({...prev, [name]: value}));
    };

    const handlePhoneCountryChange = (e) => {
        let value = e.target.value;
        if (value && !value.startsWith('+')) {
            value = '+' + value;
        }
        value = value.replace(/[^\d+]/g, '');
        if (value.length > 5) {
            value = value.slice(0, 5);
        }
        setFormData(prev => ({...prev, phoneCountryCode: value}));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            let userEmail
            const walletAddress = localStorage.getItem('walletAddress');
            if (!walletAddress) {
                userEmail = localStorage.getItem('userEmail');

            } else {
                userEmail = formData.email
            }
            const user_id = localStorage.getItem('userId');
            // Prepare the request body
            const requestBody = {
                robot_name: robotName,
                user_id: user_id,
                first_name: formData.firstName,
                last_name: formData.lastName,
                phone_number: `${formData.phoneCountryCode} ${formData.phoneNumber}`,
                email: userEmail,
                project_company: formData.projectCompany,
                location: formData.location,
                telegram: formData.telegram,
                token: gatewayToken
            };
            const response = await fetch(`${PRISMAX_BACKEND_URL}/api/reserve-robot`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (data.success) {
                setIsSuccess(true);
            } else {
                console.error('Reservation failed:', data.msg);
                alert(data.msg || 'Failed to submit reservation. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting reservation:', error);
            showNotification('error', "An error occurred. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // If submission was successful, show success modal
    if (isSuccess) {
        return ReactDOM.createPortal(
            <div className={styles.modalOverlay} onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}>
                <div className={`${styles.modalContainer} `}>

                    <div className={styles.successContent}>
                        <div style={{justifyContent: "flex-end"}} className={styles.reserveModalHeader}>
                            <img src={closeButton} className={styles.closeBtn} onClick={onClose} alt='Close modal'/>
                        </div>
                        <img src={reserveSuccessImg} alt='checkmark' style={{marginBottom: '24px'}}/>
                        <h2 className={styles.successTitle}>Your reservation has been confirmed</h2>
                        <p className={styles.successSubtitle}>Someone from our team will soon get in contact with
                            you</p>

                        <div className={styles.robotImageContainer} style={{marginBottom: '80px'}}>
                            <img src={robotImage} alt={robotName} className={styles.robotImage}/>
                        </div>
                    </div>
                </div>
            </div>,
            document.getElementById('root')
        );
    }

    // Regular form view
    return ReactDOM.createPortal(
        <div className={styles.modalOverlay} onClick={(e) => {
            if (e.target === e.currentTarget) {
                onClose();
            }
        }}>
            <div className={`${styles.modalContainer} ${styles.reserveModalContainer}`}>
                <div className={styles.reserveModalHeader}>
                    <button onClick={onGoBack || onClose} className={styles.goBackButton}>
                        <img src={GoBackArrow} alt='<'/> Go Back
                    </button>
                    <img src={closeButton} className={styles.closeBtn} onClick={onClose} alt='Close modal'/>
                </div>

                <h2 className={styles.reserveModalTitle}>Reserve {robotName}</h2>
                <p className={styles.reserveModalSubtitle}>
                    We will need this information to get in contact with you and define the reservation details and
                    arrange the shipment.
                </p>

                <form onSubmit={handleSubmit} className={styles.reserveForm}>
                    <div className={styles.formRow}>
                        <div className={styles.formField}>
                            <label htmlFor="firstName">FIRST NAME*</label>
                            <input type="text" id="firstName" name="firstName" value={formData.firstName}
                                   onChange={handleChange} placeholder="First name" required/>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor="lastName">LAST NAME*</label>
                            <input type="text" id="lastName" name="lastName" value={formData.lastName}
                                   onChange={handleChange} placeholder="Last name" required/>
                        </div>
                    </div>

                    <div className={styles.formRow}>
                        <div className={styles.formField}>
                            <label htmlFor="phoneNumber">PHONE NUMBER*</label>
                            <div className={styles.phoneInputContainer}>
                                <input
                                    type="text"
                                    name="phoneCountryCode"
                                    value={formData.phoneCountryCode}
                                    onChange={handlePhoneCountryChange}
                                    className={styles.phoneCountrySelect}
                                    placeholder="+1"
                                    aria-label="Phone country code"
                                    style={{width: '80px',marginRight:'2px'}}
                                    required
                                />
                                <input
                                    type="tel"
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    placeholder="772 5000"
                                    required
                                    className={styles.phoneNumberInput}
                                />
                            </div>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor="email">EMAIL ADDRESS*</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="john@gmail.com"
                                required
                                disabled={hasStoredEmail}
                            />
                        </div>
                    </div>

                    <div className={styles.formField}>
                        <label htmlFor="projectCompany">PROJECT/COMPANY</label>
                        <input type="text" id="projectCompany" name="projectCompany" value={formData.projectCompany}
                               onChange={handleChange} placeholder="Your company name"/>
                    </div>

                    <div className={styles.formField}>
                        <label htmlFor="location">LOCATION</label>
                        <input type="text" id="location" name="location" value={formData.location}
                               onChange={handleChange} placeholder="San Francisco"/>
                    </div>

                    <div className={styles.formField}>
                        <label htmlFor="telegram">TELEGRAM</label>
                        <input type="text" id="telegram" name="telegram" value={formData.telegram}
                               onChange={handleChange} placeholder="Your Telegram username (optional)"/>
                    </div>

                    <button
                        type="submit"
                        className={styles.confirmReservationButton}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Confirm Reservation'}
                    </button>
                </form>
            </div>
        </div>,
        document.getElementById('root')
    );
}

export default ReserveInfoModal;